import ReactDOM from 'react-dom';
import { useOutside } from "hooks/UseOutside";
import { Dispatch, SetStateAction, useRef, useState } from "react";

import { Container, ModalContainer,  } from './_dateFilterModal';
import { ModalCloseButton } from '../SendDocumentsModal/_sendDocumentsModal';
import { ensureLastYearMonths } from 'utils/ensureLastYearMonths';
import { Select } from '../Select/Select';
import { ensureLastYears } from 'utils/ensureLastYears';
import { parseMonthRange } from 'utils/ensureMonthRange';
import moment from 'moment';

interface IDateFilterModalProps {
  toggleModal: Dispatch<SetStateAction<any>>;
  setFilterQuery: Dispatch<SetStateAction<string>>;
  callback?: () => void;
}

export const DateFilterModal = ({
  toggleModal,
  setFilterQuery,
  callback
}: IDateFilterModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [hideModal, setHideModal] = useState(false);

  const [ selectedMonth, setSelectedMonth ] = useState({
    label: '',
    value: ''
  });

  const [ selectedYear, setSelectedYear ] = useState({
    label: '',
    value: ''
  });

  const handleSetValue = () => {
    const [fullInitial, fullFinal] = parseMonthRange(new Date(+selectedYear.value, +selectedMonth.value - 1, 1));

    const initial_date = moment(fullInitial).format('YYYY-MM-DD')
    const final_date = moment(fullFinal).format('YYYY-MM-DD')

    setFilterQuery(`initial_date=${initial_date}&final_date=${final_date}`);

    handleCloseModal();
  }

  const handleCloseModal = () => {
    setHideModal(true);

    setTimeout(() => {
      toggleModal({
        total: false,
        date: false,
        services: false
      });

      if(callback){
        callback();
      }
    }, 500);
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <Container className={`${hideModal ? 'modal-date-filter--hide' : ''}`}>
      <ModalContainer ref={modalRef}>
      <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ModalCloseButton>
        <div className="modal-date-filter__select-wrapper">
          <div className="modal-date-filter__select-container">
            <label className="modal-date-filter__label">
              Mês:
            </label>
            <Select
              options={ensureLastYearMonths().map((date) => ({
                value: date.value,
                label: date.name
              }))}
              className="modal-date-filter__select"
              defaultLabel='Mês'
              selectedItem={selectedMonth}
              setSelectedItem={setSelectedMonth}
            />
          </div>
          <div className="modal-date-filter__select-container">
            <label className="modal-date-filter__label">
              Ano:
            </label>
            <Select
              options={ensureLastYears().map((date) => ({
                value: date,
                label: date
              }))}
              className="modal-date-filter__select"
              defaultLabel="Ano"
              selectedItem={selectedYear}
              setSelectedItem={setSelectedYear}
            />
          </div>
        </div>
        <button
          type="button"
          className="modal-date-filter__button"
          onClick={handleSetValue}
        >
          Confirmar
        </button>
        </ModalContainer>
    </Container>,
    modalRoot
  )
}
